import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authAPI } from '@/lib/api';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      // Check localStorage first
      const token = localStorage.getItem('session_token');
      const storedUser = localStorage.getItem('user');
      
      if (!token) {
        console.log('No token found in localStorage');
        setIsAuthenticated(false);
        return;
      }

      // If we have a stored user, use it immediately
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
          
          // Verify with server in background
          try {
            const userData = await authAPI.getMe();
            localStorage.setItem('user', JSON.stringify(userData));
            setUser(userData);
          } catch (error) {
            // Token invalid - clear storage
            if (error.response?.status === 401) {
              localStorage.removeItem('session_token');
              localStorage.removeItem('user');
              setIsAuthenticated(false);
            }
          }
          return;
        } catch (e) {
          // Invalid stored user, continue to server check
        }
      }

      // Verify token with server
      try {
        const userData = await authAPI.getMe();
        console.log('Auth verified:', userData?.email);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Auth check failed:', error.response?.status);
        localStorage.removeItem('session_token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isAuthenticated === false) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Export function to clear auth on logout
export const clearAuthCache = () => {
  localStorage.removeItem('session_token');
  localStorage.removeItem('user');
};

export default ProtectedRoute;
